import { SortOrder } from '@/enums/SortOrder';
import qs from 'qs';
import { Module, ActionTree, MutationTree, GetterTree } from 'vuex';

const initialState: ResellerState = {
  all: [],
  viewing: undefined,
};

const getters: GetterTree<ResellerState, RootState> = {
  all(state: ResellerState): Reseller[] {
    return state.all;
  },
  viewing(state: ResellerState): Reseller | undefined {
    return state.viewing;
  },
};

const mutations: MutationTree<ResellerState> = {
  RESET(state: ResellerState) {
    state.all = [];
    state.viewing = undefined;
  },
  ADD_MODEL(state: ResellerState, payload: Reseller) {
    state.all.push(payload);
  },
  ADD_MODELS(state: ResellerState, payload: Reseller[]) {
    state.all = [...state.all, ...payload];
  },
  SET_MODELS(state: ResellerState, payload: Reseller[]) {
    state.all = payload;
  },
  UPDATE_MODEL(state: ResellerState, payload: Reseller) {
    const index = state.all.findIndex((model: Reseller) => model.id === payload.id);

    if (index === -1) {
      state.all.push(payload);
    } else {
      state.all[index] = payload;
    }
  },
  REMOVE_MODEL(state: ResellerState, payload: Reseller) {
    state.all = state.all.filter((model: Reseller) => model.id !== payload.id);
  },
  SET_VIEWING(state: ResellerState, payload: Reseller) {
    state.viewing = payload;
  },
};

const resource: string = 'api/resellers';

const actions: ActionTree<ResellerState, RootState> = {
  clearViewing({ commit }) {
    commit('SET_VIEWING', undefined);
  },
  create({ commit, rootState }, payload: Reseller) {
    return rootState.api
      .post(`${resource}`, payload, { withCredentials: true })
      .then((response: { data: Reseller }) => {
        commit('ADD_MODEL', response.data);

        return Promise.resolve(response.data);
      })
      .catch((e: ErrorResponse) => {
        return Promise.reject(e);
      });
  },
  index({ commit, rootState }, payload: { query?: IndexQuery<Reseller> } = { query: { s: { created_at: SortOrder.DESC, id: SortOrder.ASC }, per_page: 20 } }) {
    const queryString = qs.stringify(payload.query, { encode: false });

    return rootState.api
      .get(`${resource}?${queryString}`, { withCredentials: true })
      .then((response: { data: Reseller }) => {
        if (payload.query?.hasOwnProperty('after')) {
          commit('ADD_MODELS', response.data);
        } else {
          commit('SET_MODELS', response.data);
        }

        return Promise.resolve(response.data);
      })
      .catch((e: ErrorResponse) => {
        return Promise.reject(e);
      });
  },
  read({ commit, rootState }, payload: { id: number }) {
    return rootState.api
      .get(`${resource}/${payload.id}`, { withCredentials: true })
      .then((response: { data: Reseller }) => {
        commit('UPDATE_MODEL', response.data);

        commit('SET_VIEWING', response.data);

        return Promise.resolve(response.data);
      })
      .catch((e: ErrorResponse) => {
        return Promise.reject(e);
      });
  },
  update({ commit, rootState }, payload: Reseller) {
    return rootState.api
      .put(`${resource}/${payload.id}`, payload, { withCredentials: true })
      .then((response: { data: Reseller }) => {
        commit('UPDATE_MODEL', response.data);

        return Promise.resolve(response.data);
      })
      .catch((e: ErrorResponse) => {
        return Promise.reject(e);
      });
  },
  delete({ commit, rootState }, payload: { id: number }) {
    return rootState.api
      .delete(`${resource}/${payload.id}`, { withCredentials: true })
      .then((response: { data: Reseller }) => {
        commit('REMOVE_MODEL', payload);

        return Promise.resolve(payload);
      })
      .catch((e: ErrorResponse) => {
        return Promise.reject(e);
      });
  },
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};
